import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Alert, Button, Typography, Box } from '@mui/material'
import useTranslations from '../../../../i18n/useTranslations'
import useStyles from './styles'

const SuccessFeedback = ({ returnNumber, onClickShowReturnsList }) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.title)}
      >
        {t('returns:success:main-title')}
      </Typography>

      <Box className={classes.infoBox}>
        <Typography variant="subtitle1" className={classes.infoBoxLabel}>
          {t('noun:return-number')}
        </Typography>
        <Typography variant="inputText" className={classes.infoBoxInfo}>
          {returnNumber}
        </Typography>
      </Box>

      <Alert severity="success" className={classes.alert}>
        <Typography variant="inputText">
          {t('returns:success:alert')}
        </Typography>
      </Alert>

      <Button size="small" onClick={() => onClickShowReturnsList('returns')}>
        {t('return:success:action:confirm')}
      </Button>
    </>
  )
}

SuccessFeedback.propTypes = {
  returnNumber: PropTypes.string,
  onClickShowReturnsList: PropTypes.func,
}

export default SuccessFeedback
